import React from 'react';
import Translate from '@src/components/Translate/Translate';
import AdjustDeadlineColorWorkHours
    from '@src/components/_layouts/Default/components/settings/deadline-timer-colors/AdjustDeadlineColorWorkHours';

export default function DeadlineTimerColorsSettings() {
    return <fieldset className="mb-3 px-1 py-2 rounded border">
        <Translate tag="legend" message="DeadlineTimerColorsSettings.title" className="classic mb-0"/>

        <AdjustDeadlineColorWorkHours
                preferenceKey="deadline-counters.red-color-since-work-hours"
                indicatorColorCssVar="--bs-danger"
                defaultValue={16}
                label="DeadlineTimerColorsSettings.display-red-color-indicator-since-work-hours"
        />

        <hr/>

        <AdjustDeadlineColorWorkHours
                preferenceKey="deadline-counters.yellow-color-since-work-hours"
                indicatorColorCssVar="--bs-warning"
                defaultValue={40}
                label="DeadlineTimerColorsSettings.display-yellow-color-indicator-since-work-hours"
        />

    </fieldset>;
}
